module.exports = __webpack_public_path__ + "img/azure-logo.6be3c5e8.svg";